import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import Regions from "../components/Regions";
import About from "../components/About";
import Capabilities from "../components/Capabilities";
import CaseStudies from "../components/CaseStudies";
import Team from "../components/Team";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

import content from "../data/content.json";
import projects from "../data/projects.json";

export default function Home() {
  return (
    <>
      <Nav />
      <main>
        <Hero data={content.hero} />
        <Stats data={content.stats} />
        <Regions data={content.regions} />
        <About data={content.about} />
        <Capabilities data={content.capabilities} />
        <CaseStudies head={content.work} projects={projects} />
        <Team data={content.team} />
        <Contact data={content.contact} />
      </main>
      <Footer />
    </>
  );
}
